import { ContactsRoute } from "@/routes/base-data/contacts/contacts-route";
import { ContactKindRoute } from "@/routes/base-data/contacts/contact-kind/contact-kind-route";
import {
  BranchesIndex,
  BranchesRoute,
} from "@/routes/base-data/branches/branches";
import MatchesRoute from "@/routes/base-data/dynamics/matches/matches";
import { ProcessesBaseDataRoute } from "@/routes/base-data/processes/processes-base-data-route";
import { EntraRoute } from "@/routes/base-data/auth/entra/entra-route";
import { entraRoutes } from "@/routes/base-data/auth/entra/entra-routes";
import { RouteObject } from "react-router";
import { CompaniesRoute } from "@/routes/base-data/companies/companies-route";
import { companiesRoutes } from "@/routes/base-data/companies/companies-routes";
import { processesBaseDataRoutes } from "@/routes/base-data/processes/processes-base-data-routes";
import { numbersBaseDataRoutes } from "@/routes/base-data/numbers/numbers-base-data-routes";
import { NumbersBaseDataRoute } from "@/routes/base-data/numbers/numbers-base-data-route";
import { BranchRoute } from "@/routes/base-data/branches/[branchId]/branch-route";
import { TextblocksBaseDataRoute } from "./textblocks/textblocks-base-data-route";
import { textblocksBaseDataRoutes } from "./textblocks/textblocks-base-data-routes";
import { SamplesBaseDataRoute } from "./samples/samples-base-data-route";
import { samplesBaseDataRoutes } from "./samples/samples-base-data-routes";
import { BusinessCentralRoute } from "./business-central/business-central-route";
import { businessCentralRoutes } from "./business-central/business-central-routes";
import { FeatureAuthRoute } from "./auth/feature-auth/feature-auth-route";
import { AuthRoute } from "./auth/auth-route";
import {
  PestcontrolBaseDataRoute,
  PestcontrolRoute,
} from "./pestcontrol/pestcontrol-route";
import {
  PestcontrolMonitorEditorRoute,
  PestcontrolMonitorsRoute,
  PestcontrolMonitorsRoutePage,
} from "./pestcontrol/monitors-route";

export const baseDataRoutes: RouteObject[] = [
  {
    path: "auth",
    element: <AuthRoute />,
    children: [
      {
        path: "entra",
        element: <EntraRoute />,
        children: entraRoutes,
      },
      {
        path: "feature-auth",
        element: <FeatureAuthRoute />,
      },
    ],
  },
  {
    path: "branches",
    element: <BranchesRoute />,
    children: [
      {
        index: true,
        element: <BranchesIndex />,
      },
      {
        path: ":branchId",
        element: <BranchRoute />,
      },
    ],
  },
  {
    path: "companies",
    element: <CompaniesRoute />,
    children: companiesRoutes,
  },
  {
    path: "contacts",
    element: <ContactsRoute />,
    children: [
      {
        path: "contact-kind",
        element: <ContactKindRoute />,
      },
    ],
  },
  {
    path: "dynamics/matches",
    element: <MatchesRoute />,
  },
  {
    path: "business-central",
    element: <BusinessCentralRoute />,
    children: businessCentralRoutes,
  },
  {
    path: "processes",
    element: <ProcessesBaseDataRoute />,
    children: processesBaseDataRoutes,
  },
  {
    path: "numbers",
    element: <NumbersBaseDataRoute />,
    children: numbersBaseDataRoutes,
  },
  {
    path: "textblocks",
    element: <TextblocksBaseDataRoute />,
    children: textblocksBaseDataRoutes,
  },
  {
    path: "samples",
    element: <SamplesBaseDataRoute />,
    children: samplesBaseDataRoutes,
  },
  {
    path: "pestcontrol",
    element: <PestcontrolBaseDataRoute />,
    children: [
      {
        index: true,
        element: <PestcontrolRoute />,
      },
      {
        path: "monitors",
        element: <PestcontrolMonitorsRoute />,
        children: [
          {
            index: true,
            element: <PestcontrolMonitorsRoutePage />,
          },
          {
            path: ":monitorId",
            element: <PestcontrolMonitorEditorRoute />,
          },
        ],
      },
    ],
  },
];
